namespace GeniuzPOS.PosShift {
    export namespace PsTaxInvoiceHdService {
        export const baseUrl = 'PosShift/PsTaxInvoiceHd';

        export declare function Create(request: Serenity.SaveRequest<PsTaxInvoiceHdRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsTaxInvoiceHdRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsTaxInvoiceHdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsTaxInvoiceHdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PosShift/PsTaxInvoiceHd/Create",
            Update = "PosShift/PsTaxInvoiceHd/Update",
            Delete = "PosShift/PsTaxInvoiceHd/Delete",
            Retrieve = "PosShift/PsTaxInvoiceHd/Retrieve",
            List = "PosShift/PsTaxInvoiceHd/List",
            GetNextNumber = "PosShift/PsTaxInvoiceHd/GetNextNumber"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetNextNumber'
        ].forEach(x => {
            (<any>PsTaxInvoiceHdService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
